import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=1ce8471a&"
import script from "./IconCheck.vue?vue&type=script&lang=ts&"
export * from "./IconCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports